import { styled, TextField } from "@mui/material";

// Forces a background color on the Outlined text fields
// Use the MUI styled callback form to access the theme without hooks
export const FilledOutlinedStyledTextField = styled(TextField)(({ theme }) => ({
  // Target the root of the OutlinedInput to ensure styles apply correctly
  "& .MuiOutlinedInput-root": {
    backgroundColor: theme.palette.input?.background ?? "inherit",
    // Ensure the background is clipped to the border radius
    clipPath: "inset(0 round 4px)", // Optional: Helps with clipping if needed
  },
}));
